import { PROJECT_STATUS_PENDENTE } from 'library/ProjectStatus';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { HelpButton } from '../../../../../components/HelpButton';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { loadPrincipiosValores } from '../../../../../store/modules/EscolasActions';
import { openModal } from '../../../../../store/modules/ModalActions';
import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  saveProjeto,
} from '../../../../../store/modules/ProjetoActions';
import { getPropsToLabel } from '../../../../../utils/HelpButtonUtils';
import { etapaIsUnlocked } from '../../../../../utils/ProjetoUtils';

class Etapa5Card2 extends GenericProjectCard {
  stepIndex = 6;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      idPrincipiosValoresChanged: false,
      descricaoPrincipioValorChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, 5);

    this.props.loadPrincipiosValores();
  }

  idPrincipiosValoresIsValid() {
    return this.props.projeto.idPrincipiosValores
      ? this.props.projeto.idPrincipiosValores.length > 0
      : false;
  }

  descricaoPrincipioValorIsValid() {
    return this.props.projeto.descricaoPrincipioValor
      ? this.props.projeto.descricaoPrincipioValor.length > 0
      : false;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = 5;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoComponenteCurricular:
        this.props.projeto.descricaoComponenteCurricular,
      descricaoAtividadeDesenvolvida:
        this.props.projeto.descricaoAtividadeDesenvolvida,
      idPrincipiosValores: this.props.projeto.idPrincipiosValores,
      descricaoPrincipioValor: this.props.projeto.descricaoPrincipioValor,
      consultaPublica: this.props.projeto.consultaPublica,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa5,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa5,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [
            this.idPrincipiosValoresIsValid(),
            this.descricaoPrincipioValorIsValid(),
          ];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa5}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa5,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <NewAutoCompleteField
                label={
                  <>
                    {this.props.languageValues.idPrincipiosValores}
                    <HelpButton
                      text={this.props.languageValues.etapa5card2PrincipiosHint}
                      {...getPropsToLabel()}
                    />
                  </>
                }
                placeholder={
                  this.props.escolas.loadingPrincipioValorList
                    ? this.props.languageValues.carregandoPrinciposValores
                    : ''
                }
                options={this.props.escolas.principioValorList.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                    disabled: item.id === 1 || item.id === 2,
                  };
                })}
                value={this.props.projeto.idPrincipiosValores}
                multiple
                onChange={(value) => {
                  const currValue = value ? value.map((val) => val.value) : [];
                  this.setValue(
                    {
                      target: {
                        name: 'idPrincipiosValores',
                        value: currValue,
                      },
                    },
                    null,
                    () => {
                      SnackbarUtils.enqueueSnackbar({
                        message:
                          this.props.languageValues.erroDeletarPrincipioFixed,
                        options: {
                          variant: 'error',
                        },
                      });
                    }
                  );
                }}
                loading={this.props.escolas.loadingPrincipioValorList}
                loadingMessage={
                  this.props.languageValues.carregandoPrinciposValores
                }
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
                error={!this.idPrincipiosValoresIsValid()}
                helperText={
                  !this.idPrincipiosValoresIsValid()
                    ? this.props.languageValues.validations.principiosValores
                        .required
                    : ''
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoPrincipioValor}
                name='descricaoPrincipioValor'
                value={this.props.projeto.descricaoPrincipioValor || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoPrincipioValorIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa5,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  escolas: state.escolas,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadPrincipiosValores,
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa5Card2));
